'use client'

import { useTranslation } from '@/hooks/client/use-translation'

import type { UpgradeComparisonHighlight } from './upgrade-comparison'

export const PriceUpgradeDiffRow = ({ highlight }: { highlight: UpgradeComparisonHighlight }) => {
  const { t } = useTranslation()
  const added = highlight.baseValue == null
  return (
    <li className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 py-2.5">
      <button
        type="button"
        data-spec-tooltip-id={highlight.tooltipId}
        data-tracking="ignore"
        className="cursor-help text-left text-sm text-navy underline decoration-navy-40 decoration-dotted underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lapis"
      >
        {highlight.name}
      </button>
      {highlight.missing ? (
        <span className="text-sm font-semibold text-navy-60">{t('product.purchase.notIncluded', 'Not included')}</span>
      ) : added ? (
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#12803f]">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="shrink-0">
            <circle cx="10" cy="10" r="10" />
            <path
              d="m5.5 10 3 3 6-6"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {t('product.panel.added', 'Added')}
        </span>
      ) : (
        <span className="text-sm font-semibold text-navy">
          {highlight.value}{' '}
          <span className="text-xs font-medium text-navy-60">
            {t('product.panel.vs', 'vs {{value}}', { value: highlight.baseValue ?? '' })}
          </span>
        </span>
      )}
    </li>
  )
}
